import { Component } from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { Platform } from '@ionic/angular';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { PermissionService } from './services/permission.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  isIOS = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private platform: Platform,
    public permissionService: PermissionService
  
  ) {
    this.initializeApp();
    this.platform.ready().then(() => {
      this.isIOS = this.platform.is('ios');
    });
  }

  // Initialize app
  // initializeApp() {

  //   // Wait until platform is ready
  //   this.platform.ready().then(async () => {

  //     // If we're on a mobile platform (iOS / Android), not web
  //     if (Capacitor.getPlatform() !== 'web') {
  //       // Set StatusBar style (dark / light)
  //       await StatusBar.setStyle({ style: Style.Light });
  //     }

  //     // ...
  //     // do some more config and setup if necessary
  //     // ...
  //     const is_signed_in = (await this.authService.getSession());
  //     if(is_signed_in){
  //     // this.router.navigateByUrl('/dashboard');
  //     }else{
  //       this.router.navigateByUrl('/signin');
  //     }

  //     // Fake timeout since we do not load any data
  //     setTimeout(async () => {
  //       // Hide SplashScreen
  //       await SplashScreen.hide();
  //     }, 2000);
  //   });
  // }

  initializeApp() {

  this.platform.ready().then(async () => {

    if (Capacitor.getPlatform() !== 'web') {
      await StatusBar.setStyle({ style: Style.Light });
    }

    // 1. GET TOKEN
    const token = localStorage.getItem('token');

    // 2. GET PERMISSIONS
    const permissions = localStorage.getItem('permissions');

    if (permissions) {
      this.permissionService.setPermissions(JSON.parse(permissions));
    }

    // 3. NAVIGATION LOGIC (IMPORTANT FIX)
    if (token && permissions) {

      // go to tabs (NOT dashboard directly)
      // this.router.navigateByUrl('/tabs');
      this.router.navigateByUrl('/dashboard');

    } else {

      this.router.navigateByUrl('/signin');
    }

    setTimeout(async () => {
      await SplashScreen.hide();
    }, 1000);
  });
}
}
